export var LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export var LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export var LOAD_USER_FAILURE = 'LOAD_USER_FAILURE';
export var SAVE_CAMPAIGN_FAILURE = 'SAVE_CAMPAIGN_FAILURE';
export var LOAD_CAMPAIGN_REQUEST = 'LOAD_CAMPAIGN_REQUEST';
export var LOAD_CAMPAIGN_SUCCESS = 'LOAD_CAMPAIGN_SUCCESS';
export var LOAD_CAMPAIGN_FAILURE = 'LOAD_CAMPAIGN_FAILURE';
export var RESET_CURRENT_CAMPAIGN = 'RESET_CURRENT_CAMPAIGN';
export var LOAD_CAMPAIGN_FEASIBILITY_REQUEST = 'LOAD_CAMPAIGN_FEASIBILITY_REQUEST';
export var LOAD_CAMPAIGN_FEASIBILITY_SUCCESS = 'LOAD_CAMPAIGN_FEASIBILITY_SUCCESS';
export var LOAD_CAMPAIGN_FEASIBILITY_FAILURE = 'LOAD_CAMPAIGN_FEASIBILITY_FAILURE';
export var LOAD_QUALIFICATIONS_REQUEST = 'LOAD_QUALIFICATIONS_REQUEST';
export var LOAD_QUALIFICATIONS_SUCCESS = 'LOAD_QUALIFICATIONS_SUCCESS';
export var LOAD_QUALIFICATIONS_FAILURE = 'LOAD_QUALIFICATIONS_FAILURE';
export var LOAD_QUALIFICATION_REQUEST = 'LOAD_QUALIFICATION_REQUEST';
export var LOAD_QUALIFICATION_SUCCESS = 'LOAD_QUALIFICATION_SUCCESS';
export var LOAD_QUALIFICATION_FAILURE = 'LOAD_QUALIFICATION_FAILURE';
export var LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST = 'LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST';
export var LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS = 'LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS';
export var LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE = 'LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE';
export var LOAD_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST = 'LOAD_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST';
export var LOAD_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS = 'LOAD_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS';
export var LOAD_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE = 'LOAD_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE';
export var LOAD_CAMPAIGN_TAP_SURVEY_REQUEST = 'LOAD_CAMPAIGN_TAP_SURVEY_REQUEST';
export var LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS = 'LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS';
export var LOAD_CAMPAIGN_TAP_SURVEY_FAILURE = 'LOAD_CAMPAIGN_TAP_SURVEY_FAILURE';
export var LOAD_DEVELOPER_QUALIFICATIONS_REQUEST = 'LOAD_DEVELOPER_QUALIFICATIONS_REQUEST';
export var LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS = 'LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS';
export var LOAD_DEVELOPER_QUALIFICATIONS_FAILURE = 'LOAD_DEVELOPER_QUALIFICATIONS_FAILURE';
